import { io } from "socket.io-client"
import userService from "@/services/userService"

class SocketService {
  socket

  connect() {
    if (this.socket && this.socket.connected) {
      return
    }

    this.socket = io({
      path: "/api/live/",
    })

    this.socket.on("connect", () => {
      console.log("WebSocket verbunden!", this.socket.id)

      // Sende die eigene User-ID, um dem richtigen Raum beizutreten
      const userId = userService.getUserId()
      if (userId) {
        this.socket.emit("join_room", userId)
      }
    })
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
    }
  }

  // Methode, um auf Events zu lauschen
  on(eventName, callback) {
    if (this.socket) {
      this.socket.on(eventName, callback)
    }
  }

  off(eventName) {
    if (this.socket) {
      this.socket.off(eventName)
    }
  }
}

export default new SocketService()
